/**
 * Lost & found: author "found/complete" CTA + toast copy.
 * Tuples are [ko, en, vi, ru].
 */

const lostFound = {
  markResolved: ['찾음 완료', 'Mark as found', 'Đã tìm thấy', 'Найдено'],
  markResolvedConfirm: [
    '이 글을 찾음(완료)으로 표시할까요? 홈·목록에서 더 이상 보이지 않아요.',
    'Mark this post as found? It will no longer appear on Home or the list.',
    'Đánh dấu bài này là đã tìm thấy? Nó sẽ không còn hiện trên trang chủ và danh sách.',
    'Отметить объявление как найденное? Оно исчезнет с главной и из списка.',
  ],
  markResolvedDone: [
    '찾음으로 표시했어요',
    'Marked as found',
    'Đã đánh dấu tìm thấy',
    'Отмечено как найденное',
  ],
  markResolvedFail: [
    '완료 처리에 실패했어요. 다시 시도해 주세요.',
    "Couldn't mark as found. Please try again.",
    'Không thể đánh dấu. Vui lòng thử lại.',
    'Не удалось отметить. Попробуйте ещё раз.',
  ],
  expiredHint: [
    '30일이 지나면 홈에서 자동으로 내려가요',
    'Posts older than 30 days leave the home feed automatically',
    'Bài quá 30 ngày sẽ tự biến mất khỏi trang chủ',
    'Объявления старше 30 дней автоматически скрываются с главной',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

function buildLang(langIndex) {
  return {
    lostFound: pick(lostFound, langIndex),
  };
}

export const phaseLostFoundResolveKo = buildLang(0);
export const phaseLostFoundResolveEn = buildLang(1);
export const phaseLostFoundResolveVi = buildLang(2);
export const phaseLostFoundResolveRu = buildLang(3);
